export var PriceHistoryLabels;
(function (PriceHistoryLabels) {
    PriceHistoryLabels["PRICE"] = "price";
    PriceHistoryLabels["CUSTUMISATION_PRICE"] = "customisationPrice";
    PriceHistoryLabels["CONTAINER_FEE"] = "containerFee";
})(PriceHistoryLabels || (PriceHistoryLabels = {}));
